import type { FaireCategoryEntity } from "../../entity_types/category";

export const catalog_cat_home_fragrances: FaireCategoryEntity = {
  token: "catalog_cat_home-fragrances",
  type: "category",
  name: "Home fragrances",
  count: 2,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
